// components/plan/PlanOverview.js
import React from 'react'

const PlanOverview = ({ plan, setEditedPlan, editable = false }) => {
  

  const handleChange = (field, value) => {
    if (!editable) return
    setEditedPlan(prev => ({ ...prev, [field]: value }))
  }

  const fields = [
    ['group_name', 'Group Name'],
    ['group_id', 'Group ID'],
    ['benefit_year', 'Plan Year'],
    ['plan_benefit_year', 'Benefit Period'],
    ['insurance_company', 'Insurance Company'],
    ['customer_service_phone', 'Phone'],
  ]

  const getValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj)
  }

  const renderField = (field, label) => {
    const value = getValue(plan, field) || ''
    if (editable) {
      return (
        <div key={field}>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.25rem' }}>{label}</label>
          <input
            type="text"
            value={value}
            onChange={(e) => handleChange(field, e.target.value)}
            style={{
              width: '100%',
              padding: '0.4rem',
              fontSize: '0.85rem',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>
      )
    }
    return (
      <div key={field}>
        <strong>{label}:</strong> {value || '—'}
      </div>
    )
  }

  return (
    <div style={{ flex: 1, background: '#f8fafc', padding: '0.6rem', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
      <h3 style={{ fontSize: '0.95rem', marginBottom: '0.5rem', marginTop: 0, fontWeight: 600 }}>Plan Overview</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', fontSize: '0.8rem', lineHeight: 1.35}}>
        {fields.map(([field, label]) => renderField(field, label))}
      </div>
    </div>
  )
}

export default PlanOverview
